<div mat-dialog-title>
  <p class="header">
    @switch (templateType) {
      @case (TEMPLATE_TYPE.TABLE_VIEW) {
        @if (translate.currentLang === 'bi') {
          <p [translate-lang]="[translateKeys]" class="m-0"></p>
        } @else {
          <p class="m-0">{{ title | translate }}</p>
        }
        <span><img class="close_icon" [src]="Icons.close" width="20px" alt="" (click)="onClose()" /></span>
      }
      @case (TEMPLATE_TYPE.LITE) {
        @if (translate.currentLang === 'bi') {
          <p [translate-lang]="[translateKeys]" class="m-0"></p>
        } @else {
          <p class="m-0">{{ title | translate }}</p>
        }
      }
    }
  </p>
</div>

<mat-dialog-content class="dialog_content">
  <div [ngClass]="{ box_content: templateType === TEMPLATE_TYPE.TABLE_VIEW }">
    <ng-container *ngTemplateOutlet="tempDialog"></ng-container>
  </div>
</mat-dialog-content>
